import * as yup from 'yup';

import sectors, { Sector } from '../../variables/sectors';
import activities, { Activity } from '../../variables/activities';
import { languagesOptions } from '../../languages';
import validator from '../../utils/validator';
import User from '../../view-model/users/User';

export const sectorAndActivitySchema = yup.object().shape({
    sector: yup
        .string()
        .strict(true)
        .typeError('Campo inválido.')
        .required('Campo é obrigatório.')
        .oneOf(sectors.map(option => option.value), 'Campo inválido.')
        .default(null),
    activity: yup
        .string()
        .strict(true)
        .typeError('Campo inválido.')
        .required('Campo é obrigatório.')
        .default(null)
        .when('sector', (sector: Sector, schema: yup.StringSchema) =>
            schema.oneOf(activities.filter(activity => activity.sector === sector).map(option => option.value), 'Campo inválido.')
        )
});

export type SectorAndActivityValue = yup.TypeOf<typeof sectorAndActivitySchema> & {
    sector: Sector,
    activity: Activity
};

const userGeneralDataSchema = sectorAndActivitySchema.concat(
    yup.object().shape({
        // TOOD: verificar tamanho limite dos campos no banco e corrigir aqui
        firstName: yup
            .string()
            .strict(true)
            .typeError('Campo inválido.')
            .required('Campo é obrigatório.')
            .min(2, 'Campo inválido.')
            .default(''),
        lastName: yup
            .string()
            .strict(true)
            .typeError('Campo inválido.')
            .required('Campo é obrigatório.')
            .min(2, 'Campo inválido.')
            .default(''),
        login: yup
            .string()
            .strict(true)
            .typeError('Campo inválido.')
            .required('Campo é obrigatório.')
            .email('Campo inválido.')
            .default(''),
        phone: yup
            .string()
            .strict(true)
            .typeError('Campo inválido.')
            .required('Campo é obrigatório.')
            .test('phone', 'Campo inválido.', value => validator.isValidPhone(value))
            .default(''),
        isWhatsapp: yup
            .boolean()
            .strict(true)
            .typeError('Se o telefone tem WhatsApp está inválido.')
            .default(false),
        language: yup
            .string()
            .strict(true)
            .typeError('Campo inválido.')
            .required('Campo é obrigatório.')
            .oneOf(languagesOptions.map(option => option.value), 'Campo inválido.')
            .default('automatic')
    })
);

export type UserGeneralDataValue = yup.TypeOf<typeof userGeneralDataSchema> & SectorAndActivityValue & {
    language: User['language']
};

export default userGeneralDataSchema;
